import React from 'react';

import { AccentColor } from 'helpers/AccentColorHelper';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import FlatButton from 'material-ui/FlatButton';

import Lottie from 'react-lottie';
import successAnimationData from 'assets/success.json';
import { getTranslatedString } from 'helpers/i18n';

const defaultOptions = {
  loop: false,
  autoplay: true,
  animationData: successAnimationData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const AutopaySuccessDialog = ({ autopaySetupSuccess, closeAutopaySuccessDialog, isSplitPay }) => (
  <Dialog
    disableBackdropClick
    open={autopaySetupSuccess}
    isModal
    aria-labelledby="autopay-setup-successful"
    classes={{
      paper: 'form-dialog',
    }}
  >
    <DialogTitle id="add-payment-details">
      <div style={{ margin: '20px', textAlign: 'center' }}>
        <Lottie options={defaultOptions} height={150} width={150} />
      </div>
      <h3 style={{ textAlign: 'center', margin: 0 }}>{getTranslatedString('autopay.success')}</h3>
    </DialogTitle>
    <DialogContent>
      <div style={{ textAlign: 'center', padding: '0px 20px' }}>
        <p style={{ marginBottom: '20px' }}>
          { isSplitPay ?
            getTranslatedString('autopay.yourAutopayDetailsUpdated')
            :
            getTranslatedString('autopay.yourDetailsHaveBeenSent')
          }
        </p>
        <FlatButton
          label={getTranslatedString('autopay.close')}
          onClick={closeAutopaySuccessDialog}
          primary={true}
          backgroundColor={AccentColor()}
          hoverColor="grey"
          style={{ color: 'white' }}
        />
      </div>
    </DialogContent>
  </Dialog>
);

export default AutopaySuccessDialog;
